import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../../config/NaeSSchema";

class InvoiceModel extends Model {
  static reducer(action, InvoiceModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Invoice.schema:
        action.payload.forEach((payload) => {
          const dbData = InvoiceModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          InvoiceModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
InvoiceModel.modelName = "InvoiceModel";

InvoiceModel.fields = {
  id: attr(),
};

export default InvoiceModel;